import React from 'react'

import Medical from './medical'
import Bones from './bones'
import Women from './women'
import BabyCar from './babyCar'
import BabyFace from './babyFace'

export const iconMap = {
  30: Medical,
  32: BabyFace,
  33: Bones,
  96: Women,
  31: BabyCar,
  1: Medical,
  3: BabyFace,
  4: Bones,
  5: Women,
  2: BabyCar,
  default: Medical
}
